import context from '@/context'

export const initialState = {
  pages: {},
  show: {},
  saving: {},
  editing: {}
}

export const actionTypes = {
  loaded: 'help/loaded',
  toggle: 'help/toggle',
  saving: 'help/saving',
  saved: 'help/saved',
  saveFailed: 'help/saveFailed',
  edit: 'help/edit',
  cancel: 'help/cancel'
}

export const actionCreators = {
  load: key => dispatch => {
    context.api.helpService.getHelp(getKey(key)).then(dto => {
      dispatch({ type: actionTypes.loaded, key: key, data: dto || {} })
    }).catch(() => {

    })
  },
  toggle: key => (
    { type: actionTypes.toggle, key }
  ),
  save: (key, text, latinText, failAction) => (dispatch) => {
    dispatch({ type: actionTypes.saving, key })
    context.api.helpService.saveHelp({ key: getKey(key), text, latinText }).then((result) => {
      if (result) {
        dispatch({ type: actionTypes.saved, key, data: { key, text, latinText } })
      } else {
        if (failAction && typeof failAction === 'function') { failAction() }
        dispatch({ type: actionTypes.saveFailed, key })
      }
    }).catch(() => {
      dispatch({ type: actionTypes.saveFailed, key })
    })
  },
  edit: key => (
    { type: actionTypes.edit, key }
  ),
  cancel: key => (
    { type: actionTypes.cancel, key }
  )
}

function getKey (key) {
  return context.config.name + key
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.loaded: {
      return { ...state, pages: { ...state.pages, [action.key]: action.data } }
    }
    case actionTypes.toggle: {
      const shown = state.show[action.key]
      let show = { ...state.show }
      let editing = state.editing
      if (shown) {
        delete show[action.key]
        editing = { ...editing }
        delete editing[action.key]
      } else {
        show[action.key] = true
      }
      return { ...state, show, editing }
    }
    case actionTypes.saving: {
      return { ...state, saving: { ...state.saving, [action.key]: true } }
    }
    case actionTypes.saved: {
      let saving = { ...state.saving }
      delete saving[action.key]
      let editing = { ...state.editing }
      delete editing[action.key]
      return { ...state, editing, saving, pages: { ...state.pages, [action.key]: action.data } }
    }
    case actionTypes.saveFailed: {
      let saving = { ...state.saving }
      delete saving[action.key]
      return { ...state, saving }
    }
    case actionTypes.edit: {
      return { ...state, editing: { ...state.editing, [action.key]: true } }
    }
    case actionTypes.cancel: {
      let editing = { ...state.editing }
      delete editing[action.key]
      return { ...state, editing }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/Help.js